// Tiny, intent-named wrappers around the shared .alert classes.
// Reduces the repetition of "alert alert-info" + the same loading text.

export function LoadingState({ children = 'Loading...' }) {
  return <div className="alert alert-info">{children}</div>;
}

export function EmptyState({ children = 'No records found.' }) {
  return <div className="alert alert-info">{children}</div>;
}

export function ErrorState({ children }) {
  return <div className="alert alert-error">{children}</div>;
}

export function InfoNote({ children }) {
  return (
    <div style={{ fontSize: 12, color: '#666', alignSelf: 'flex-end', paddingBottom: 4 }}>
      {children}
    </div>
  );
}
